import React from 'react';
import { SpacingName, TypographyName } from '@doveit/lego';
import CreateLeadSection from '../../templates/common/create-lead-section/CreateLeadSection';
import { TextAlign } from '../../types';
import { sendLeadSubmitEventAndRedirect } from '../../utils/tracking';
import PageSection from '../page-section/PageSection';

export interface ContactUsSectionProps {
  title: string,
  id?: string,
  content?: string,
  formTitle?: string,
  padding?: SpacingName | SpacingName[],
}

export const ContactUsSection: React.FC<ContactUsSectionProps> = ({
  title,
  content,
  id = 'contattaci',
  formTitle = 'Compila il form, sarai ricontattato entro 48h',
  padding,
}) => (
  <PageSection padding={padding} id={id}>
    <PageSection.Wrapper withoutPad>
      <PageSection.Title
        size={TypographyName.H3}
        textAlign={TextAlign.CENTER}
      >
        {title}
      </PageSection.Title>
      {content && (
        <PageSection.Description
          text={content}
          textAlign={TextAlign.CENTER}
          size={TypographyName.H4}
          color="neutrals.dark"
        />
      )}
      <CreateLeadSection
        title={formTitle}
        dataRef="lead-form-main"
        onSuccess={(lead) => sendLeadSubmitEventAndRedirect('main', lead)}
        dataTracking="lead-form-main-submit"
      />
    </PageSection.Wrapper>
  </PageSection>
);

export default ContactUsSection;
